/** Sticky top bar: brand, filename, open-another-file, export. */
import { useRef } from 'preact/hooks'
import { store } from '../state/store'
import { downloadExport } from '../state/export'
import { exportViolations } from './uiState'

export function Header() {
  const input = useRef<HTMLInputElement>(null)

  function openAnother(files: FileList | null): void {
    const file = files?.[0]
    if (!file) return
    if (store.canReset.value && !confirm('Discard edits to the current file and open another?')) {
      return
    }
    void file.arrayBuffer().then((buf) => store.loadFile(new Uint8Array(buf), file.name))
  }

  return (
    <header class="topbar">
      <span class="brand">Swim Editor</span>
      <span class="filename">{store.fileName.value}</span>
      <span class="spacer" />
      <button class="btn" onClick={() => input.current?.click()}>
        Open another file
      </button>
      <input
        ref={input}
        type="file"
        accept=".fit,.FIT"
        hidden
        onChange={(e) => openAnother((e.target as HTMLInputElement).files)}
      />
      <button
        class="btn btn-primary"
        onClick={() => {
          exportViolations.value = downloadExport(store)
        }}
      >
        Export .fit
      </button>
    </header>
  )
}
